import { createSlice, AnyAction } from "@reduxjs/toolkit";
import type { FileAllViewState } from "@types";

const initialState: FileAllViewState = {
  tabSelected: "liveScheduled",
  rowsTileToggleValue: "rows",
  showResetButton: false,
  filter: {
    queryKeys: ["file_id", "title", "description", "location"],
    startDateTime: "",
    searchValue: "",
    idKey: "file_id",
  },
  sortBy: {
    sortKey: "file_location_id",
    reverse: true,
  },
  fileLocationFilter: {
    queryKeys: ["file_location_id", "location_name", "directoryLocation"],
    searchValue: "",
    idKey: "file_location_id",
  },
  trashFilter: {
    queryKeys: ["location_name"],
    searchValue: "",
    idKey: "location_name",
  },
  filesExtensionsToExclude: ["html", "zip"],
};

const fileAllViewSlice = createSlice({
  name: "fileAllView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("SEARCH_TABLE_VALUES", (state, action: AnyAction) => {
        state.filter.searchValue = action.searchValue;
        state.fileLocationFilter.searchValue = action.searchValue;
        state.trashFilter.searchValue = action.searchValue;
        state.showResetButton =
          state.showResetButton || action.searchValue !== "";
      })
      .addCase("CLICK_TAB", (state, action: AnyAction) => {
        state.tabSelected = action.status;
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("SET_TABLE_VIEW", (state, action: AnyAction) => {
        state.rowsTileToggleValue = action.view;
      })
      .addCase("SET_FILTER_DATE", (state, action: AnyAction) => {
        state.showResetButton = true;
        if (action.timeSelected === "start") {
          state.filter.startDateTime = action.dateTime;
        }
      })
      .addCase("RESET_FILTER_ALL", (state) => {
        state.filter = initialState.filter;
        state.fileLocationFilter = initialState.fileLocationFilter;
        state.trashFilter = initialState.trashFilter;
        state.showResetButton = false;
      })
      .addCase("OPEN_IMAGE_UPLOADED_CONTAINER", (state) => {
        (state as any).setShowImageUpload = true;
      })
      .addCase("CLOSE_IMAGE_UPLOADED_CONTAINER", (state) => {
        (state as any).setShowImageUpload = false;
      })
      .addCase("SET_SORT_PARAM", (state, action: AnyAction) => {
        state.sortBy.sortKey = action.sortKey;
        state.sortBy.reverse = action.reverse;
      });
  },
});

export const selectFileAllView = (state: {
  fileAllView: FileAllViewState;
}): FileAllViewState => state.fileAllView;

export default fileAllViewSlice.reducer;
